import DataTable from "datatables.net-react";
import $ from 'jquery';
import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import Button from 'react-bootstrap/Button';
import Select from 'react-select';
import { TradeLogServices } from "../../services/TradeLogServices";
import * as BullCache from "../../util/BullCache";
import AdminDropdown from "../components/AdminDropdown";
import BrokerDropdown from '../components/BrokerDropdown';
import ClientDropdown from "../components/ClientDropdown";
import { customStyles, the } from "../components/customStyles";
import From from '../components/From';
import MarketDropdown from '../components/MarketDropdown';
import MasterDropdown from '../components/MasterDropdown';
import ScriptDropdown from '../components/ScriptDropdown';
import To from '../components/To';
import '../custom.css';
import { getTodayDate } from "../../util/Utils"

function Rejectionlog() {
  const [loading, setLoading] = useState(false);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [master, setMaster] = useState([]);
  const [data, setData] = useState([]);
  const [selectedMaster, setSelectedMaster] = useState(null);
  const [selectedBroker, setSelectedBroker] = useState(null);
  const [selectedSubBrokerId, setSelectedSubBrokerId] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedMarket, setSelectedMarket] = useState(null);
  const [selectedScript, setSelectedScript] = useState(null);
  const [fromDate, setFromDate] = useState(getTodayDate());
  const [toDate, setToDate] = useState(getTodayDate());
  const [selectedOrderType, setSelectedOrderType] = useState(null);
  const [selectedBrokerId, setSelectedBrokerId] = useState(null);
  const [calledFirstTime, setCalledFirstTime] = useState(false);



  var user = BullCache.getFromCache("user");

  var allScripts = BullCache.getFromCache('allScripts');

  const handleMarketChange = (market) => {
    setSelectedMarket(market);
  };

  const handleScriptChange = (script) => {
    setSelectedScript(script);
  };

  const handleScriptReset = () => {
    setSelectedScript(null);
  };

  const handleFromDateChange = (newDate) => {
    setFromDate(newDate);  // Update fromDate whenever it changes
  };

  const handleSelectedClientChange = (selected) => {
    setSelectedClient(selected?.userId); // selected is an object { userId: '...' }
  };

  const handleOrderTypeChange = (selectedOption) => {
    setSelectedOrderType(selectedOption);
  };
  const option = [
    { value: 'market', label: ' Market' },
    { value: 'limit', label: 'Limit' },
  ];
  useEffect(() => {
    if (fromDate && toDate && !calledFirstTime) {
      const dataToSubmit = {
        adminId: user.adminId,
        date: fromDate,
        endDate: toDate,
        status: "ERROR"
      };

      fetchData(dataToSubmit);
      setCalledFirstTime(true);
    }
  }, [fromDate, toDate]);

  const fetchData = (dataToSubmit) => {
    setLoading(true);
    TradeLogServices.getTableData(dataToSubmit)
      .then((resp) => {
        setLoading(false);
        if (resp.code === 1 && resp.data.logList.length > 0) {
          setData(resp.data.logList);
        } else {
          setData([]);
        }
      })
      .catch((error) => {
        console.error('Error fetching trade data:', error);
      });
  };

  const columns = [
    { title: 'ACTION', data: 'action' },
    { title: 'CLIENT', data: 'client',className: "text-nowrap"  },
    { title: 'SYMBOL', data: 'script', className: "text-nowrap"  },
    { title: 'ORDER TYPE', data: 'orderType', className: "text-nowrap page-wrapper" },
    { title: 'LOT', data: 'lot' },
    { title: 'QTY', data: 'quantity' },
    { title: 'ORDER PRICE', data: 'rate' },
    { 
      title: 'MESSAGE', 
      data: 'remark', 
      className: "text-nowrap page-wrapper",
      render: function(data, type, row) {
          return data ? data : ''; // Default message when remark is null
      }
  },
    { title: 'O-TIME', data: 'orderTime', className: "text-nowrap" },
    {
      title: 'USER IP',
      render: (data, type, full, meta) => {
        const ip = full.ip;
        if (!ip) return null; 
        return `<a href="https://whatismyipaddress.com/ip/${ip}" target="_blank">${ip}</a>`;
      },
    },
  ];

  const handleReset = () => {
    
    setSelectedMarket( null );
    setSelectedScript(null);
    setSelectedOrderType(null);
    setSelectedAdmin(null);
    setSelectedMaster(null);
    setSelectedBrokerId(null);
    setSelectedSubBrokerId(null);
    setSelectedClient(null);

  };

  const handleSubmit = () => {
    setLoading(true);
    const dataToSubmit = {
      adminId: user.adminId,
      keyword: selectedScript,
      segment: selectedMarket,
      date: fromDate,
      endDate: toDate,
      status: "ERROR"
    };

    if (selectedClient) {
      dataToSubmit.userId = selectedClient;
      dataToSubmit.adminId = user.adminId;
    } else if (selectedSubBrokerId) {
      dataToSubmit.adminId = selectedSubBrokerId.value;
    } else if (selectedBrokerId) {
      dataToSubmit.adminId = selectedBrokerId;
    } else if (selectedMaster) {
      dataToSubmit.adminId = selectedMaster.value;
    } else if (selectedAdmin) {
      dataToSubmit.adminId = selectedAdmin.value;
    }

    TradeLogServices.getTableData(dataToSubmit)
      .then((resp) => {
        setLoading(false);
        if (resp.code === 1) {
          if (resp.data.logList.length > 0) {
            setData(resp.data.logList);
          }
          else {
            setData([]);
          }
        } else {
          setData([]);
        }
      })
      .catch((error) => {
        console.error('Error fetching trade data:', error);
      });

  };

  return (
    <div className="container-fluid">
      <Card className="mt-2">
        <Card.Body>
          <Row>
            <Col sm={4} xl={3} xs={12}>
              <Row className="d-flex align-items-center">
                <Col sm={6} xs={6} >
                  <b className='fss-05'>FROM DATE</b><br />
                  <From fromDate={fromDate} onDateChange={handleFromDateChange} />
                </Col>

                <Col sm={6} xs={6}>
                  <b className='fss-05'>TO DATE</b><br />
                  <To toDate={toDate} setToDate={setToDate} />
                </Col>
              </Row>
            </Col>
            <Col sm={2} xs={6} >
              <b className="fss-05">TYPE</b>
              <Select
                options={option}
                value={selectedOrderType}
                onChange={handleOrderTypeChange}
                className='text-black'
                placeholder="Select"
                isSearchable={true}
                theme={the} styles={customStyles}
                isClearable
              />
            </Col>



            <Col sm={2} xs={6}>
              <b className='fss-05'>MARKET</b>
              <MarketDropdown allScripts={allScripts} onMarketChange={handleMarketChange} onScriptReset={handleScriptReset} />

            </Col>
            <Col sm={2} xs={6}>
              <b className='fss-05'>SCRIPT NAME</b>
              <ScriptDropdown
                allScripts={allScripts}
                selectedMarket={selectedMarket}
                onScriptChange={handleScriptChange}
              />
            </Col>

            {user.adminType == 'SUPER_ADMIN' || user.adminType == 'SUPER_MASTER'?
              <>
                <Col sm={2} xs={6}>
                  <b className="fss-05">ADMIN</b>
                  <AdminDropdown
                    adminId={user.adminId}
                    setSelectedOption={setSelectedAdmin} />
                </Col>
              </> : ""}

          </Row>
          <Row>
            <Col xl={3}>

            </Col>
            {user.adminType == 'SUPER_ADMIN' || user.adminType == 'ADMIN' || user.adminType == 'SUPER_MASTER' ?
              <>
                <Col sm={2} xs={6}>
                  <b className="fss-05">MASTER</b>
                  <MasterDropdown
                    adminId={user.adminId}
                    selectedAdmin={selectedAdmin}
                    setSelectedOption={setSelectedMaster}
                    setSelectedMaster={setSelectedMaster}
                    setSelectedBrokerId={setSelectedBrokerId}
                  />
                </Col>
              </> : ""}

          
            <Col sm={2} xs={6}>
              <b className="fss-05">CLIENT</b>
              <ClientDropdown
                selectedAdmin={selectedAdmin}
                selectedMaster={selectedMaster}
                selectedBrokerId={selectedBrokerId}
                //  selectedSubBrokerId={selectedSubBrokerId}
                setSelectedOption={handleSelectedClientChange}
              />

            </Col>
            <Col sm={3} xs={6} className="mt-4 ">
              <Button variant="success" size="sm" className="w-50 me-2" onClick={handleSubmit}>
                SEARCH
              </Button>

              <Button variant="danger" size="sm" className="" onClick={handleReset}>
                RESET
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="mt-1">
        <Card.Body className="p-1 mb-4">
          <div className="table-responsive">
            {loading ? (
              <div className="container vh-100">
                <div className="d-flex align-items-center justify-content-center h-90">
                  <div className="spinner-border text-secondary m-5" role="status" style={{ width: '4rem', height: '4rem' }}>
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            ) : (
              <DataTable className=" table table-striped text-center  bg-secondary-row fss-06"
                columns={columns} data={data}
                options={{
                  createdRow: function (row, data) {
                    if (data.orderType.includes("Buy")) {
                      $(row).addClass('buy-row');
                    } else if (data.orderType.includes("Sell")) {
                      $(row).addClass('sell-row');
                    }
                  },
                }}
              />
            )}
          </div>
        </Card.Body>
      </Card>
    </div>
  )
}
export default Rejectionlog;